import { useState, useEffect, useCallback } from "react";
import Amplify, { Auth } from "aws-amplify";
import {
  CognitoUser,
  CognitoUserSession,
  CognitoIdToken,
  CognitoRefreshToken,
  CognitoAccessToken,
} from "amazon-cognito-identity-js";
import jwtDecode from "jwt-decode";

function useAuth() {
  const [authenticated, setAuthenticated] = useState(false);
  const [token, setToken] = useState<string>("");
  const [userDetails, setUserDetails] = useState<any>({});
  const myLuToken = sessionStorage.getItem("myluToken")!;

  const auth = useCallback(() => {
    Auth.currentSession()

      .then((session) => {
        setToken(session.getIdToken().getJwtToken());
        setUserDetails(session.getIdToken().decodePayload());
        setAuthenticated(true);
      })

      .catch((err) => {
        //@ts-ignore
        Auth.federatedSignIn({ provider: "Lancaster-University" });
      });
  }, []);

  useEffect(() => {
    if (myLuToken) {
      setToken(myLuToken);
      setUserDetails(jwtDecode(myLuToken));
      setAuthenticated(true);
    } else {
      auth();
    }
  }, [auth, myLuToken]);

  return { token, userDetails, authenticated };
}

export default useAuth;
